import { useContext, useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { isRubiconInternalEmail } from "./common/utils";
import { AuthStateContext } from "./contexts/AuthContext";
import { IUser } from "./types";

const ProtectedPage = ({
  children,
  requireInternal = false,
}: {
  children: React.ReactNode;
  requireInternal?: boolean;
}) => {
  const { currentUser, checkUserAuthStatus } = useContext(AuthStateContext);
  const location = useLocation();
  const navigate = useNavigate();

  const user = currentUser as IUser | null;
  const profileEditPath = user?.id ? `/users/${user.id}/profile/edit` : null;

  const needsProfileUpdate = !!user && user.profile_update_required !== false;
  const onProfileEditPage =
    profileEditPath !== null && location.pathname === profileEditPath;

  const internalBlocked =
    !!user && requireInternal && !isRubiconInternalEmail(user.email);

  useEffect(() => {
    if (!currentUser) {
      checkUserAuthStatus(true);
    }
  }, []);

  useEffect(() => {
    if (needsProfileUpdate && profileEditPath && !onProfileEditPage) {
      navigate(profileEditPath, { replace: true });
    }
  }, [needsProfileUpdate, profileEditPath, onProfileEditPage]);

  useEffect(() => {
    if (internalBlocked) {
      navigate("/", { replace: true });
    }
  }, [internalBlocked]);

  if (!currentUser) {
    return <></>;
  }

  if (user?.has_temp_pw) {
    window.location.href = "/changepassword";
    return <></>;
  }

  if (needsProfileUpdate && !onProfileEditPage) {
    return <></>;
  }

  if (internalBlocked) {
    return <></>;
  }

  return <>{children}</>;
};

export default ProtectedPage;
